/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const imagesPrefix =
  "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-design-system/presentation/sections";

export default [
  {
    title: "Ongoing Projects",
    description: "A selection of 45 page sections that fit perfectly in any combination",
    items: [
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 10,
        route: "/sections/page-sections/page-headers",
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 14,
        route: "/sections/page-sections/features",
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 8,
        pro: true,
      }
    ],
  },
  {
    title: "Projected Completed",
    description: "30+ components that will help go through the pages",
    items: [
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 4,
        route: "/sections/navigation/navbars",
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 2,
        route: "/sections/navigation/nav-tabs",
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/ka_5-768x576.jpeg`,
        name: "नेपाल जलवायु नमुना कार्यक्रम नेपाल सरकारबाट स-शर्त अनुदान प्राप्त",
        count: 3,
        route: "/sections/navigation/pagination",
      },
    ],
  },
  {
    title: "Upcoing Projects",
    description: "50+ elements that you need for text manipulation and insertion",
    items: [
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/26e9b770-e6fd-4910-8bb1-74c21ab00b09-300x169.jpeg`,
        name: "पालिकाहरुको वनक्षेत्रका सरोकारवालाहरुको वार्षिक भेला (Annual Municipality Forest Sector Stakeholder Forum)",
        count: 6,
        pro: true,
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/26e9b770-e6fd-4910-8bb1-74c21ab00b09-300x169.jpeg`,
        name: "पालिकाहरुको वनक्षेत्रका सरोकारवालाहरुको वार्षिक भेला (Annual Municipality Forest Sector Stakeholder Forum)",
        count: 8,
        pro: true,
      },
      {
        image: `https://dfoharionmun.technovateconsult.com/wp-content/uploads/2023/06/26e9b770-e6fd-4910-8bb1-74c21ab00b09-300x169.jpeg`,
        name: "पालिकाहरुको वनक्षेत्रका सरोकारवालाहरुको वार्षिक भेला (Annual Municipality Forest Sector Stakeholder Forum)",
        count: 3,
        route: "/sections/input-areas/forms",
      }
    ],
  }
];
